export const SHOWHIDETOAST = 'SHOW_HIDE_TOAST';

export interface ShowHideToastAction {
  type: typeof SHOWHIDETOAST;
  status: boolean;
  color: string;
  message: string
}